import { observer } from "mobx-react-lite";
import { useTranslations } from "next-intl";

import { Icon } from "@/components/icons/Icon";
import { VisibilityToggle } from "@/components/VisibilityToggle";
import { useStore } from "@/store";
import { twMerge } from "@/utils/twMerge";

type PositionType = "left" | "right";

type Props = {
  position: PositionType;
  className?: string;
  isVisible?: boolean;
  onToggle?: () => void;
};

export const SidebarVisibilityToggle = observer(function SidebarVisibilityToggle({
  position,
  className,
  onToggle = () => {},
}: Props) {
  const { view } = useStore();
  const isExpanded =
    position === "left" ? view.leftSidebarState === "full" : view.rightSidebarState === "full";

  const handleClick = () => {
    if (position === "left") {
      view.toggleLeftSidebar();
    } else {
      view.toggleRightSidebar();
    }

    onToggle();
  };
  const t = useTranslations("view");
  const label = t(`sidebarToggle.${position}.${isExpanded ? "hide" : "show"}`);

  return (
    <VisibilityToggle
      label={label}
      onClick={handleClick}
      className={twMerge(
        className,
        position === "right" && "rounded-l-6",
        position === "left" && "rounded-r-6",
      )}
    >
      <Icon
        name="HideSidebar"
        className={twMerge(
          position === "right" && isExpanded && "rotate-180",
          position === "left" && !isExpanded && "rotate-180",
        )}
      />
    </VisibilityToggle>
  );
});
